import React from 'react';

import './TaskListItemDragHandle.scss';

type Props = {
    DragHandleComponent: React.ComponentType;
};

const TaskListItemDragHandle: React.FC<Props> = ({ DragHandleComponent }) => (
    <div className="task-list-item-drag-handle-container" contentEditable={false}>
        <DragHandleComponent />
    </div>
);

export default TaskListItemDragHandle;
